var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '@mui/material/Tooltip';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DownloadingIcon from '@mui/icons-material/Downloading';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import { CatalogProcessStatus } from '../../../models/catalogs/CatalogProcess';
function statusIcon(_a) {
    var status = _a.status, _b = _a.header, header = _b === void 0 ? false : _b;
    var size = header ? 96 : 30;
    switch (status) {
        case CatalogProcessStatus.COMPLETED:
            return _jsx(Tooltip, __assign({ sx: { fontSize: size }, title: "Sync Complete, No Issues" }, { children: _jsx(TaskAltIcon, {}) }));
        case CatalogProcessStatus.COMPLETED_WITH_ISSUE:
            return _jsx(Tooltip, __assign({ sx: { fontSize: size }, title: "Sync Complete, Issues Found" }, { children: _jsx(WarningAmberIcon, {}) }));
        case CatalogProcessStatus.FAILED:
            return _jsx(Tooltip, __assign({ sx: { fontSize: size }, title: "Sync Failure" }, { children: _jsx(HighlightOffIcon, {}) }));
        case CatalogProcessStatus.IN_PROGRESS:
            return _jsx(Tooltip, __assign({ sx: { fontSize: size }, title: "In Progress" }, { children: _jsx(DownloadingIcon, {}) }));
        default:
            return _jsx(Tooltip, __assign({ sx: { fontSize: size }, title: "Error Retrieving Status" }, { children: _jsx(SyncProblemIcon, {}) }));
    }
}
export function CatalogStatusIcon(_a) {
    var status = _a.status, header = _a.header;
    return statusIcon({ status: status, header: header });
}
